import {
  Card,
  CardBody,
  Input,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
// import ExportData from "components/common/ExportData";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import BookingsTable from "components/bookings/BookingsTable";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import Somethingwentwrong from "pages/Somethingwentwrong";
import useAsync from "hooks/useAsync";
import useFilter from "hooks/useFilter";
import { useState, useContext, useEffect, useRef } from "react";
import BookingServices from "services/BookingServices";
import BookingsDrawerCity from "components/drawer/BookingsDrawerCity";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import Loader from "components/form/Loader";
import { SidebarContext } from "context/SidebarContext";
import { FiPlus } from "react-icons/fi";
import InputSearchDate from "components/form/InputSearchDate";
import LabelArea from "components/form/LabelArea";
import DataWrapper from "./DataWrapper";
import sidebar from "routes/sidebar";
import useBookingSubmit from "hooks/useBookingSubmit";
import SelectSingleCities from "components/form/SelectSingleCities";
import { useLocation } from "react-router-dom";
//import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

// import { FiPlus } from "react-icons/fi";

const Bookings = () => {
  const location = useLocation();
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  // const { state } = useContext(AdminContext);
  // const { adminInfo } = state;
  const [searchstartDate, setSearchStartDate] = useState(null);
  const [searchendDate, setSearchEndDate] = useState(null);
  const params = new URLSearchParams(location.search);
  const urlType = Number(params.get("type"));

  const [type, setType] = useState(urlType || 2);

  const { register } = useBookingSubmit();
  const [status, setStatus] = useState("");
  const [selectedCity, setSelectedCity] = useState(null);

  const isAdmin = adminInfo?.id_profile === 1;
  const showSensitiveColumns = isAdmin;
  const istrans = adminInfo?.id_profile === 2;

  const hideView = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bookings" && perm.view === 1,
      );
  const hideEdit = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bookings" && perm.edit === 1,
      );

  const hideAdd = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bookings" && perm.add === 1,
      );

  const hideExport = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bookings" && perm.export === 1,
      );

  const hideDelete = isAdmin
    ? true
    : adminInfo?.permission?.some(
        (perm) => perm.id_tab === "bookings" && perm.delete === 1,
      );
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };
  // is_executive / is_seller are no longer sent from the client — the backend
  // derives the scoping condition from the authenticated employee's own profile.
  const formattedDates = {
    type: type,
    city: selectedCity,
    start_date: searchstartDate ? formatDate(searchstartDate) : null,
    end_date: searchendDate ? formatDate(searchendDate) : null,
  };

  // const { data, loading } = useAsync(BookingServices.getAllBookings(adminInfo.id, formattedDates));
  const { data, loading, error } = useAsync(() =>
    BookingServices.getFilterBookings(adminInfo.id, formattedDates),
  );
  // console.log("response data...",data);

  const [searchTerm, setSearchterm] = useState("");
  const { toggleDrawer, functionLoading, setIsUpdate } =
    useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  // const [itemsPerPage] = useState(10);

  const parseDMY = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const urlType = Number(params.get("type"));
    if (urlType && urlType !== type) {
      setType(urlType);
    }
    const start = params.get("start");
    const end = params.get("end");
    if (start && end) {
      setSearchStartDate(parseDMY(start));
      setSearchEndDate(parseDMY(end));
    }
  }, [location.search]);

  useEffect(() => {
    setIsUpdate(true);
  }, [type]);
  // console.log("typppppppppppppppp",type)

  const { bookingRef, serviceData, currentPage } = useFilter(
    Array.isArray(data.data) ? data.data : [],
  );

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const updatedData = data?.data?.map((item, index) => {
    return {
      "SI.No": index + 1,
      "Ref No": item.ref_no || "",
      "Agent Ref": item.agentref || "",
      "Agent Name": item.agentname || "",
      "Client Name": item.client_name || "",
      "Package Type": item.package_type || "",
      "Start Date": item.start_date || "",
      "End Date": item.end_date || "",
      Arrival: item.arrival || "",
      Departure: item.departure || "",
      "Booking Date": item.booking_date || "",
      Note: item.special_note || item.vehicle_note,
      Duration: item.duration || item.no_of_days || "",
      "Vehicle Type": item.client_vehicle_name || "",
      "Selling Price": item.selling_price || "",
      Seller: item.seller || "",
      Franchise: item.franchise_name || "",
      Vendor: item.vendor_name || "",
      Driver: item.driver_name || "",
      "Vehicle Remark": item.vehicle_remark || item.vehicle_note || "",
      // Cancel: !!item.cancel_reason,
      Cancel: item.cancel_reason ? "Cancelled" : "Not Cancelled",
    };
  });
  // console.log("Excel export data:", updatedData);

  // const updatedData = Object.entries(data?.data || {}).flatMap(([ref_no, bookings]) => {
  //   return bookings.map((item) => {
  //     const { id, is_active, block_status, ...rest } = item;
  //     return rest;
  //   });
  // });

  const handleSearch = () => {
    setIsUpdate(true);
  };

  // Booking grouping/reconciliation (dedupe by ref_no, current vs history
  // vehicles/vendors) is now done server-side — see groupBookingsByRefNo
  // in b2bcabs_api/lib/common-function/groupBookingsByRefNo.js
  const groupedAgents = Array.isArray(data?.data) ? data.data : [];

  // Apply search filter
  const searchTerms = searchTerm.toLowerCase().split(" ");
  const filteredAgents = groupedAgents.filter((agent) => {
    return searchTerms.every(
      (term) =>
        agent?.online_or_offline?.toLowerCase().includes(term) ||
        agent?.ref_no?.toLowerCase().includes(term) ||
        agent?.agentname?.toLowerCase().includes(term) ||
        agent?.agentref?.toLowerCase().includes(term) ||
        agent?.client_name?.toLowerCase().includes(term) ||
        agent?.package_type?.toLowerCase().includes(term) ||
        agent?.arrival?.toLowerCase().includes(term) ||
        agent?.start_date?.toLowerCase().includes(term) ||
        agent?.end_date?.toLowerCase().includes(term) ||
        agent?.is_online?.toString().includes(term) ||
        agent?.seller?.toString().includes(term),
    );
  });

  // Slice data for the current page
  const paginatedAgents = filteredAgents;
  const handleRefresh = () => {
    setSearchEndDate(null);
    setSearchStartDate(null);
    setIsUpdate(true);
    setSearchterm("");
    setSelectedCity("");
    buttonStyle(1);
    // setType(1);
  };

  const buttonStyle = (buttonType) => ({
    borderRadius: "0",
    padding: "12.5px 10px",
    fontSize: "11px",
    cursor: "pointer",
    outline: "none",
    flex: "1",
    whiteSpace: "nowrap",
  });

  const [isCollapsed, setIsCollapsed] = useState(true);

  const contentRef = useRef(null);
  const [height, setHeight] = useState("0px");

  useEffect(() => {
    if (contentRef.current) {
      setHeight(isCollapsed ? `${contentRef.current.scrollHeight}px` : "0px");
    }
  }, [isCollapsed]);

  const buttonName = [
    "All",
    "Arrival",
    "Departure",
    "Surface Arrival",
    "Surface Departure",
    "Today Created",
    "Confirmed",
    "Canceled",
  ];

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <MainDrawer>
            <BookingsDrawerCity id={serviceId} />
          </MainDrawer>
          <PageTitle sidebar={sidebar().sidebar} />

          <Card
            className="min-w-0 shadow-xs bg-white dark:bg-gray-800 mb-5"
            style={{ overflow: "visible" }}
          >
            <CardBody>
              <div className="relative">
                {/* Collapsible Section */}
                <div
                  ref={contentRef}
                  className="transition-all duration-300 ease-in-out"
                  style={{
                    height: height,
                    opacity: isCollapsed ? 1 : 0,
                    overflow: isCollapsed ? "visible" : "hidden",
                  }}
                >
                  <div className="flex items-center gap-3">
                    <div className="flex items-center gap-2">
                      <LabelArea label="Start Date" />
                      <div className="w-40">
                        <InputSearchDate
                          value={searchstartDate}
                          onChange={(event) => setSearchStartDate(event)}
                        />
                      </div>
                    </div>

                    <div className="flex items-center gap-2">
                      <LabelArea label="End Date" />
                      <div className="w-40">
                        <InputSearchDate
                          value={searchendDate}
                          min={searchstartDate}
                          onChange={(event) => setSearchEndDate(event)}
                        />
                      </div>
                    </div>

                    <div className="flex items-center gap-2 flex-1">
                      <LabelArea label="Destination" />
                      <div className="w-full">
                        <SelectSingleCities
                          register={register}
                          label="City"
                          name="city"
                          type="text"
                          placeholder={"--Choose--"}
                          selectedCity={selectedCity}
                          handleCityChange={setSelectedCity}
                        />
                      </div>
                    </div>

                    <Button
                      className="rounded-md h-10 px-8"
                      onClick={() => {
                        handleSearch();
                      }}
                    >
                      Search
                    </Button>

                    {hideExport && (
                      <ExportDataXlsx
                        title="Bookings"
                        exportDataXlsx={updatedData}
                        fileNames="Bookings"
                        startDate={searchstartDate}
                        endDate={searchendDate}
                      />
                    )}

                    <div className="text-green-600 text-md cursor-pointer">
                      <span
                        onClick={() => {
                          handleRefresh();
                        }}
                      >
                        Reset
                      </span>
                    </div>
                  </div>
                </div>

                {/* Main Controls */}
                <div className={`flex gap-3 ${isCollapsed ? "mt-5" : ""}`}>
                  <Input
                    ref={bookingRef}
                    className="border h-10 text-sm focus:outline-none block flex-1 bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    placeholder="Quick Search"
                    autoComplete="off"
                    style={{ width: "auto" }}
                    onChange={(e) => setSearchterm(e.target.value)}
                  />

                  {/* Buttons */}
                  <div className="flex rounded-lg overflow-hidden">
                    {buttonName.map((name, index) => (
                      <button
                        key={index}
                        style={{ fontSize: "11px" }}
                        className={`px-4 py-1 cursor-pointer focus:outline-none transition-colors whitespace-nowrap
      ${
        type === index + 1
          ? "bg-green-500 text-white"
          : "bg-gray-300 dark:bg-gray-600 dark:text-gray-400"
      }
    `}
                        onClick={() => setType(index + 1)}
                      >
                        {name}
                      </button>
                    ))}
                  </div>
                  {hideAdd && (
                    <button
                      onClick={toggleDrawer}
                      className="createButton rounded-md h-10"
                      style={{ width: "80px", fontSize: "12px" }}
                    >
                      <span className="mr-2">
                        <FiPlus size={20} />
                      </span>
                      Create
                    </button>
                  )}

                  {/* Collapse Button */}
                  {/* <button
                    className="border-none pl-4 py-2 focus:outline-none text-green-500 transition-transform duration-300 ease-in-out text-xl"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                  >
                    {isCollapsed ? (
                      <IoIosArrowUp className="rotate-0" />
                    ) : (
                      <IoIosArrowDown className="rotate-180" />
                    )}
                  </button> */}
                </div>
              </div>
            </CardBody>
          </Card>
          {functionLoading && <Loader message="Please wait..." />}

          <DataWrapper loading={loading} error={error} status={status}>
            {/* after some datesearch or quicksearch was not working properly change
             below paginatedAgents:(paginatedAgents?.length !== 0) tooo 
             set this serviceData:(serviceData?.length !== 0)*/}

            {paginatedAgents?.length !== 0 ? (
              <TableContainer>
                <div
                  className="overflow-scroll "
                  style={{ maxHeight: "65vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize text-center sticky top-0 z-10 text-sm">
                      <tr>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>Ref No</TableCell>
                        {showSensitiveColumns && (
                          <TableCell>Agent/Ref No. </TableCell>
                        )}
                        <TableCell>Client Name </TableCell>
                        {/* <TableCell>Online/Offline </TableCell> */}
                        <TableCell>Service Type</TableCell>
                        <TableCell>Trip Date</TableCell>
                        <TableCell>Arrival / Departure</TableCell>

                        <TableCell>Booking Date</TableCell>
                        {showSensitiveColumns && (
                          <TableCell>Itinerary Details</TableCell>
                        )}
                        <TableCell>Note</TableCell>
                        <TableCell>Duration</TableCell>
                        <TableCell>Vehicle Type</TableCell>
                        {!istrans && <TableCell>Selling Price</TableCell>}

                        <TableCell>Seller</TableCell>
                        {showSensitiveColumns && (
                          <TableCell>Arrival Executive</TableCell>
                        )}
                        {/* <TableCell>Departure Executive</TableCell> */}
                        <TableCell>Transporter/Vendor</TableCell>
                        <TableCell>Franchise</TableCell>
                        <TableCell>Driver</TableCell>
                        {/* <TableCell>Vehicle</TableCell> */}
                        {showSensitiveColumns && <TableCell>Invoice</TableCell>}
                        <TableCell>Vehicle Remark</TableCell>
                        {showSensitiveColumns && (
                          <TableCell>Feedback</TableCell>
                        )}
                        {hideEdit && <TableCell>Cancel / Reason</TableCell>}
                        {/* <TableCell>Reason for canceled</TableCell> */}
                        {showSensitiveColumns && (
                          <TableCell>Arrival Status</TableCell>
                        )}
                        {hideView && <TableCell>Actions</TableCell>}
                      </tr>
                    </TableHeader>
                    <BookingsTable
                      agents={paginatedAgents}
                      // perpage={itemsPerPage}
                      currentPage={currentPage}
                      hideEdit={hideEdit}
                      hideView={hideView}
                      hideAdd={hideAdd}
                      // hideDelete={hideDelete}
                      hideExport={hideExport}
                      showSensitiveColumns={showSensitiveColumns}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {data.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There are no Bookings." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default Bookings;
